import {
  buildFacebookPdpAttributes,
  commonFacebookEventsUtil,
} from '@/shared/features/analytics/utils/facebookCommonAttributes';
import type { ProductDetail } from '../../domain/models/ProductDetail';
import type { PdpEffectiveProductVm } from '../viewModels/pdp.vm';

export function facebookAddToCart(
  product: ProductDetail,
  vm: PdpEffectiveProductVm,
  selectedSizeDisplay?: string,
): void {
  commonFacebookEventsUtil(
    'AddToCart',
    buildFacebookPdpAttributes(product, vm, selectedSizeDisplay)
  );
}
